module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-coj_b-4d1b6db7ed6fe2ee005bb012be2c6d3c.jpg";